import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material/';
import theme from './assets/theme';
import './assets/global.css';
import '@fontsource/urbanist';
import '@fontsource/urbanist/500.css';
import '@fontsource/urbanist/700.css';
import './assets/icons/style.css';
import 'aos/dist/aos.css';

import { HelmetProvider } from 'react-helmet-async';

// Encuentra el elemento raíz en el DOM
const rootElement = document.getElementById('root');

// Crea el root con createRoot
const root = ReactDOM.createRoot(rootElement);

// Renderiza la aplicación
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
